import { z } from 'zod';

import { DefinitionItem } from './language';

export const BusinessUnit = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(false),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
  division: z
    .object({
      id: z.string().default(''),
      name: z.string().default(''),
    })
    .default({ id: '', name: '' }),
  divisionId: z.string().default(''),
  valueDeliveredDepartment: z.object({ id: z.string(), name: z.string() }).nullable().default(null),
  defaultEpmMasterRoleType: z.object({ id: z.string(), name: z.string() }).nullable().default(null),
  definitions: z.array(DefinitionItem).default([]),
});
export type BusinessUnitType = z.infer<typeof BusinessUnit>;
